export const REPORT_STEP_KEYS = [
  "information",
  "custProperty",
  "financial-overview",
  "maintenance",
];
